import { render, staticRenderFns } from "./genderRate.vue?vue&type=template&id=5f712a65&"
import script from "./genderRate.vue?vue&type=script&lang=js&"
export * from "./genderRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports